import request from "../../utils/api";

export const login = params => {
  return request("v1/sellers/login", {
    method: "post",
    body: params
  });
};

export const changePassword = params => {
  return request("v1/sellers/change-password", {
    method: "post",
    body: params
  });
};

export const customerLogin = params => {
  return request("v1/sellers/customer-login", {
    method: "post",
    body: params
  });
};

export const forgotPassword = params => {
  return request("v1/sellers/password/email", {
    method: "post",
    body: params
  });
};

export const resetPassword = params => {
  return request("v1/sellers/password/reset", {
    method: "post",
    body: params
  });
};


export const logout = params => {
  return request("v1/sellers/logout", {
    method: "post",
    body: params
  });
};